import React, { FC, useEffect, useContext } from 'react';
import * as Sentry from '@sentry/react';
import { useLocation } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
import { Flex } from '@dripcapital/dripui-v1';
import { OnBoardingRoutes } from './routes';
import { useReactiveVar } from '@apollo/client';
import { Snackbar } from 'atoms';
import { SnackbarVariantEnum } from 'enums';
import { messageVar } from 'config/server';
import { AnalyticsContext } from 'shared/context/AnalyticsContext';

type AppProps = object;

const App: FC<AppProps> = () => {
  const location = useLocation();
  const { mixpanel, mouseflow } = useContext(AnalyticsContext);

  const { messages, messagesStyle = {} } = useReactiveVar(messageVar);

  useEffect(() => {
    mixpanel.trackPageView(location.pathname);
    mouseflow.newPageView(location.pathname);
  }, [location, mixpanel, mouseflow]);

  const renderSnackbar = ({
    message,
    variant,
    timer = 3000,
  }: {
    message?: string;
    variant?: string;
    timer?: number;
  }) => {
    return (
      <>
        <Snackbar
          open={!!messages?.length}
          title={message || ''}
          variant={(variant as SnackbarVariantEnum) || 'success'}
          autoHideDuration={timer}
          _sx={{
            position: 'static',
            marginBottom: 1,
          }}
          onClose={() => {
            messageVar({
              messages: [],
              messagesStyle: {},
            });
          }}
        />
      </>
    );
  };

  const renderSnackBarStack = () => {
    return (
      <Flex
        direction={'column'}
        alignItems={'flex-end'}
        flexWrap={'nowrap'}
        _sx={{
          position: 'fixed',
          top: '96px',
          right: '2%',
          width: '100%',
          zIndex: '10',
          ...messagesStyle,
        }}
      >
        {messages?.map((message, index) => {
          return (
            <React.Fragment key={index}>
              {renderSnackbar(message)}
            </React.Fragment>
          );
        })}
      </Flex>
    );
  };

  // const getCSPHeaders = () => {
  //   return (
  //     <Helmet>
  //       <meta httpEquiv="Content-Security-Policy" content={getCSPHeader()} />
  //     </Helmet>
  //   );
  // };

  return (
    <>
      {/* {getCSPHeaders()} */}
      {renderSnackBarStack()}
      <OnBoardingRoutes />
    </>
  );
};

export default Sentry.withErrorBoundary(App, {
  fallback: <div>An error has occurred</div>,
});
